/**
 * Status badge styling for the OKR performance table.
 *
 * Split out of `OKRPerformanceTable.tsx` so the S1-g coverage guard
 * (`utils/__tests__/okrStatus.test.ts`) can assert this map covers the whole status
 * vocabulary without importing the component — which pulls in `components/common`, whose
 * `ErrorBoundary` uses `import.meta` and cannot be loaded under ts-jest's CommonJS output.
 *
 * Labels come from `utils/okrStatus` so they cannot drift between this app's status maps.
 * The colours stay here because they are specific to this table.
 */

import { OKR_STATUS_LABELS } from '../../utils/okrStatus';

export const STATUS_BADGES: Record<string, { label: string; className: string }> = {
  draft: { label: OKR_STATUS_LABELS.draft, className: 'bg-stone-100 text-stone-600' },
  active: { label: OKR_STATUS_LABELS.active, className: 'bg-blue-100 text-blue-700' },
  on_track: { label: OKR_STATUS_LABELS.on_track, className: 'bg-green-100 text-green-700' },
  at_risk: { label: OKR_STATUS_LABELS.at_risk, className: 'bg-amber-100 text-amber-700' },
  off_track: { label: OKR_STATUS_LABELS.off_track, className: 'bg-red-100 text-red-700' },
  completed: { label: OKR_STATUS_LABELS.completed, className: 'bg-green-100 text-green-700' },
  closed: { label: OKR_STATUS_LABELS.closed, className: 'bg-stone-100 text-stone-600' },
  deleted: { label: OKR_STATUS_LABELS.deleted, className: 'bg-stone-100 text-stone-500' },
  // Not in the S1-g vocabulary and written by nothing in this repo. Kept because production
  // runs tenants whose rows have not been measured here, and falling back is worse.
  cancelled: { label: 'Cancelled', className: 'bg-stone-100 text-stone-500' },
};
